/**
 * Truncate preview text without breaking inline math delimiters / LaTeX commands.
 * Broken `$…` or mid-`\times` cuts cause KaTeX to fail and leak raw `\times`/`\div`.
 */
export function truncateMathAwarePreview(text: string, maxLen: number): string {
  const raw = String(text || '').replace(/\s+/g, ' ').trim();
  if (!raw) return '';
  if (raw.length <= maxLen) return balanceInlineDollars(raw);

  let cut = raw.slice(0, Math.max(8, maxLen));
  // Don't end mid LaTeX command: `...\tim` / `...\times`
  cut = cut.replace(/\\[a-zA-Z]{0,24}$/, '');
  cut = cut.replace(/\s+$/, '');

  const dollars = (cut.match(/\$/g) || []).length;
  if (dollars % 2 === 1) {
    const last = cut.lastIndexOf('$');
    // Drop incomplete trailing math segment when it's a short stub.
    if (last >= 0 && cut.length - last < 48) {
      cut = cut.slice(0, last).replace(/\s+$/, '');
    } else {
      cut = `${cut}$`;
    }
  }

  const display = cut.endsWith('…') ? cut : `${cut}…`;
  return balanceInlineDollars(display.replace(/\$…$/, '…').replace(/\$\s*…$/, '…'));
}

function balanceInlineDollars(text: string): string {
  // Ignore $$ pairs for simple parity of single $
  const withoutDisplay = text.replace(/\$\$[\s\S]*?\$\$/g, '');
  const singles = (withoutDisplay.match(/\$/g) || []).length;
  if (singles % 2 === 1) return `${text}$`;
  return text;
}
